import "../../../../assets/QuestionaireUFC_DC_V1/css/questionnaireUFC_DC_V1.scss";
import "../../../../assets/QuestionaireUFC_DC_V1/css/custom.scss";
import { useState, useRef, useEffect, useReducer, useContext } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import {
  wereUalreadyPayingOD,
  ApplythisFollowingOD,
} from "../../../../Constants/Questions";
import GetVisitorsParams from "../../../../Utility/GetVisitorsParams";
import { FormData } from "../../../../Utility/FormData";

import { userInfo } from "../../../../Hooks/userInfo";
import { useUpdateMilestone } from "../../../../Hooks/useUpdateMilestone";
import { useQuestionnaire } from "../../../../Hooks/useQuestionnaire";
import { useFollowupUserQuestions } from "../../../../Hooks/useFollowupUserQuestions";
import { useFollowupLoad } from "../../../../Hooks/useFollowupLoad";
import { getPageName } from "../../../../Constants/PageNames";
import VisitorParamsContext from "../../../../Contexts/VisitorParams";
import QueryStringContext from "../../../../Contexts/QueryString";

import DidTakeFurtherBorrowing from "./QuestionairesFlp/DidTakeFurtherBorrowing";
import SufferedFinancialHardship from "./QuestionairesFlp/SufferedFinancialHardship";
import RecieveAnyIncome from "./QuestionairesFlp/RecieveAnyIncome";
import MonthlyIncome from "./QuestionairesFlp/MonthlyIncome";
import Dependents from "./QuestionairesFlp/Dependents";
import WereAlreadyPaying from "./QuestionairesFlp/WereAlreadyPaying";
import IncomeAndExpV2 from "./QuestionairesFlp/IncomeAndExpV2";
import FurtherBorrowing from "./QuestionairesFlp/FurtherBorrowing";
import StruggledRepayments from "./QuestionairesFlp/StruggledRepayments";
import MaintainedCreditBalance from "./QuestionairesFlp/MaintainedCreditBalance";
import StuckInOverdraft from "./QuestionairesFlp/StuckInOverdraft";
import OccasionalUnforeseenEmergency from "./QuestionairesFlp/OccasionalUnforeseenEmergency";
import ApplythisFollowing from "./QuestionairesFlp/ApplythisFollowing";
import OfferLoans from "./QuestionairesFlp/OfferLoans";
import OpeningCreditLimit from "./QuestionairesFlp/OpeningCreditLimit";
import EverIncreCredLimit from "./QuestionairesFlp/EverIncreCredLimit";
import BankActedIrresponsibly from "./QuestionairesFlp/BankActedIrresponsibly";
import HighestCreditLimit from "./QuestionairesFlp/HighestCreditLimit";
import ExceedCreditLimit from "./QuestionairesFlp/ExceedCreditLimit";
import HowOftenExceedCredit from "./QuestionairesFlp/HowOftenExceedCredit";
import OverLimitCharges from "./QuestionairesFlp/OverLimitCharges";
import HowStuckAffects from "./QuestionairesFlp/HowStuckAffects";
import Footer from "../../../Includes/Layouts/UFC_DC_V2/Footer";
import HighestNum from "./QuestionairesFlp/HighestNum";
import { usePageLoad } from "../../../../Hooks/usePageLoad";

const initialState = {
  title1: "hide",
  occasionalUnforeseenEmergency: "hide",
  applythisFollowing: "hide",
  highestNum: "hide",
  offerLoans: "hide",
  openingCreditLimit: "hide",
  everIncresedCredLimit: "hide",
  bankActedIrresponsibly: "hide",
  highestCreditLimit: "hide",
  exceedCredLimit: "hide",
  oftenExceedCredit: "hide",
  overLimit: "hide",
  title2: "hide",
  financialHardship: "hide",
  recieveAnyIncome: "hide",
  monthlyIncome: "hide",
  dependents: "hide",
  wereAlreadyPaying: "hide",
  incmAndExp: "hide",
  title3: "hide",
  furtherBorrowing: "hide",
  struggledRepayments: "hide",
  maintainedCreditBalance: "hide",
  stuckInOverdraft: "hide",
  howStuckAffects: "hide",
  exceedCredLimitBck: "",
  financialhardshipBck: "",
  dependentsBck: "",
  didTakeFurtherBorrowing: "hide",
  struggledRepaymentsBck: "",
  highestnumBck: "",
};

const QuestionnaireReducer = (state, action) => {
  switch (action.type) {
    case "showSlideChange": {
      const updatedState = Object.keys(state).reduce((acc, key) => {
        acc[key] = key === action.payload ? "show" : "hide";
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 500);
        return acc;
      }, {});
      return { ...state, ...updatedState };
    }
    default:
      return state;
  }
};

const QuestionaireFlp = ({
  questionSlides,
  allFollowupData,
  updatePending,
  removeFromPendingFollowup,
  uuid
}) => {
  const { saveFollowupUserQuestions } = useFollowupUserQuestions();
  const splitForm = useRef(null);
  const scrollRef = useRef([]);
  const [state, dispatch] = useReducer(QuestionnaireReducer, initialState);
  const [clickedSlide, setClickedSlide] = useState([]);
  const [previousSlide, setPreviousSlide] = useState([]);
  const [optionSelected] = useState([]);
  const [everIncreased, setEverIncreased] = useState("");
  const [exceedCredit, setExceedCredit] = useState("");
  const { visitorParameters } = useContext(VisitorParamsContext);
  const query_string = localStorage.getItem("queryString");
  const formdata = JSON.parse(localStorage.getItem("formData"));
  const { setFormData } = FormData();
  const { getUserInfo } = userInfo();
  const [splitName, setSplitName] = useState();
  const [splitNameForSkip, setSplitNameForSkip] = useState();
  const [recieveIncomeback, setRecieveIncomeback] = useState("");
  const [stuckinOverdraftbck, setStuckinOverdraftbck] = useState("");
  const [strugleRepaymentsBck, setStrugleRepaymentsBck] = useState("");
  const [checklistOptions, setChecklistOptions] = useState([]);
  const [checkedOptions, setCheckedOptions] = useState([]);
  const [highestNumBck, setHighestNumBck] = useState([]);
  const [optionSelected76] = useState([]);
  const { updateMilestone } = useUpdateMilestone();
  const history = useHistory();
  state.exceedCredLimitBck = everIncreased;
  state.financialhardshipBck = exceedCredit;
  state.dependentsBck = recieveIncomeback;
  state.struggledRepaymentsBck = strugleRepaymentsBck;
  state.highestnumBck = highestNumBck;
  const scrollfrmv2div = useRef(null);
  const { loadFollowup } = useFollowupLoad();
  const split_name = localStorage.getItem("split_name");
  const { queryString } = useContext(QueryStringContext);
  const flp_source = allFollowupData.atp_sub6;
  const { savePageLoad, calledOnce } = usePageLoad();



  const { register, errors, trigger, setError, clearErrors, getValues } =
    useForm({
      mode: "onBlur",
      reValidateMode: "onChange",
      defaultValues: {},
      resolver: undefined,
      context: undefined,
      criteriaMode: "firstError",
      shouldFocusError: true,
      shouldUnregister: true,
    });



  useEffect(() => {
    setTimeout(() => {
      scrollfrmv2div.current.scrollIntoView({
        behavior: "smooth",
        top: 0,
      });
    }, 50);

    if (clickedSlide) {
      dispatch({ type: "showSlide", payload: { clickedSlide } });
      // setQuestionCounter(questionCounter + 1);
    }
  }, [clickedSlide]);

  const previousSlideChange = (e) => {
    // setQuestionCounter(questionCounter - 1);
    setPreviousSlide({ slide: e.target.getAttribute("name") });
    setTimeout(() => {
      scrollfrmv2div.current.scrollIntoView({
        behavior: "smooth",
        top: 0,
      });
    }, 50);
  };

  useEffect(() => {
    if (previousSlide) {
      dispatch({ type: "previousSlides", payload: { previousSlide } });
    }
  }, [previousSlide]);

  // useEffect(() => {
  //   if (questionSlides.length == 0) {
  //     SetPercentage(95);
  //   } else {
  //     SetPercentage(Math.round(((questionSlides.length - 1) / questionSlides.length) * 90));
  //     console.log("percenteage",Math.round(((questionSlides.length - 1) / questionSlides.length) * 90),questionSlides.length);

  //   }
  // }, [questionSlides.length]);

  useEffect(() => {
    slideChange(questionSlides);
  }, [questionSlides]);

  


  useEffect(() => {
    if (!!uuid && !calledOnce) {
      const data = {
        uuid,
        page_name: getPageName("questions"),
        status: "visited",
        source: flp_source,
      };
      (async () => {
        await savePageLoad(
          visitorParameters.visitor_parameters,
          data,
          "visited_status",
          split_name,
          queryString,
          visitorParameters.data
        );
      })();
    }
  }, [uuid, calledOnce]);



  const storeQuestionnire = async (question_data) => {
    const response = await saveFollowupUserQuestions(
      question_data,
      allFollowupData,
      "followup_question_store"
    );

  };

  const unQualifiedAnswer = (e) => {
    let selectedAns = parseInt(e.target.getAttribute("data-ans-id"));
    let selectedQuest = parseInt(e.target.getAttribute("data-quest-id"));
    let flag = false;
    let question_data = {};

    if (selectedQuest && selectedAns) {
      flag = true;
      question_data = {
        question_id: selectedQuest,
        option_id: selectedAns,
        answer_text: "",
        input_answer: null,
      };
    }

    if (flag == true) {
      storeFollowupQuestionnire(
        question_data,
        "unqualified_question_store_flp"
      );
    }
  };

  const onSelectAnswer = async (e, param) => {
    let selectedAns = parseInt(e.target.getAttribute("data-ans-id"));
    let selectedQuest = parseInt(e.target.getAttribute("data-quest-id"));
    let anslabel = e.target.getAttribute("data-ans-label");
    const valuesreg = getValues();
    let flage = false;
    let question_data = {};

    if (
      (selectedAns == "252" && selectedQuest == "95") ||
      (selectedAns && selectedQuest == "97")
    ) {
      setClickedSlide({ slide: e.target.name });
      flage = true;
      question_data = {
        question_id: selectedQuest,
        option_id: selectedAns,
        answer_text: null,
        input_answer: null,
      };

      if (selectedQuest == "95") {
        removeFromPending("exceedCredLimit");
      }
      if (selectedQuest == "97") {
        removeFromPending("overLimit");
      }
    }

    if (e.target.name == "wereAlreadyPaying") {
      setClickedSlide({ slide: e.target.name });
      if (selectedQuest) {
        flage = true;
        question_data = {
          question_id: selectedQuest,
          option_id: null,
          answer_text: "",
          input_answer: checklistOptions,
        };
      }
      removeFromPending("wereAlreadyPaying");
    }
    if (e.target.name == "furtherBorrowing") {
      setClickedSlide({ slide: e.target.name });
      if (selectedQuest) {
        flage = true;
        question_data = {
          question_id: selectedQuest,
          option_id: null,
          answer_text: "",
          input_answer: checkedOptions,
        };
      }
      removeFromPending("furtherBorrowing");
    }
    if (selectedAns && selectedQuest == 105) {
      setClickedSlide({ slide: e.target.name, slide_value: e.target.value });
      flage = true;
      question_data = {
        question_id: selectedQuest,
        option_id: selectedAns,
        answer_text: null,
        input_answer: null,
      };
      removeFromPending("stuckInOverdraft");
    }
    if (e.target.name == "applythisFollowing") {
      if (selectedQuest) {
        flage = true;
        question_data = {
          question_id: selectedQuest,
          option_id: null,
          answer_text: anslabel,
          input_answer: optionSelected,
        };
      }

      const contains308 = optionSelected.some((option) => option.id === 308);

      setClickedSlide({
        slide: "applythisFollowing",
        slide_value: contains308,
      });
      if (!contains308) {
        removeFromPending("highestNum");
      }
      removeFromPending("applythisFollowing");
    }

    if (selectedAns && selectedQuest) {
      setClickedSlide({ slide: e.target.name, slide_value: e.target.value });
      flage = true;
      question_data = {
        question_id: selectedQuest,
        option_id: selectedAns,
        answer_text: null,
        input_answer: null,
      };

      removeFromPending(e.target.name);
    }

    if (flage) {
      storeFollowupQuestionnire(question_data, "followup_question_store");
      let existingEntries = JSON.parse(localStorage.getItem("questionData"));

      if (existingEntries == null) existingEntries = [];
      localStorage.setItem(
        "currentquestionData",
        JSON.stringify(question_data)
      );
      existingEntries.push(question_data);
      localStorage.setItem("questionData", JSON.stringify(existingEntries));
    }
  };

  const saveInputAns = async (e) => {
    let selectedQuest = parseInt(e.target.getAttribute("data-quest-id"));
    let selectedAns = parseInt(e.target.getAttribute("data-ans-id"));
    let anslabel = e.target.getAttribute("data-ans-label");
    const valuesreg = getValues();
    let flage = false;
    let question_data = {};
    let openingcrditlimit = valuesreg["creditLimit"];
    let creditLimitHigh = valuesreg["creditLimitHigh"];
    let thinkback = valuesreg["thinkback"];
    let stuckAffects = valuesreg["stuckAffects"].trim();
    let highestNum = valuesreg["highestNumber"];
    let incomeMonthly = valuesreg["monthlyIncome"];

    if (
      selectedQuest == 91 &&
      openingcrditlimit &&
      e.target.name != "dontRemember"
    ) {
      setClickedSlide({ slide: e.target.name });
      flage = true;
      question_data = {
        question_id: selectedQuest,
        option_id: null,
        answer_text: "",
        input_answer: openingcrditlimit,
      };
    } else if (selectedQuest == 91 && e.target.name == "dontRemember") {
      setClickedSlide({ slide: "openingCreditLimit" });
      flage = true;
      question_data = {
        question_id: selectedQuest,
        option_id: null,
        answer_text: "",
        input_answer: "I Don't Remember",
      };
    } else if (selectedQuest == 94 && creditLimitHigh) {
      setClickedSlide({ slide: e.target.name });
      flage = true;
      question_data = {
        question_id: selectedQuest,
        option_id: null,
        answer_text: "",
        input_answer: creditLimitHigh,
      };
    } else if (selectedQuest == 99 && thinkback) {
      setClickedSlide({ slide: e.target.name });
      flage = true;
      question_data = {
        question_id: selectedQuest,
        option_id: null,
        answer_text: "",
        input_answer: thinkback,
      };
    } else if (selectedQuest == 106 && stuckAffects) {
      setClickedSlide({ slide: e.target.name });
      flage = true;
      question_data = {
        question_id: selectedQuest,
        option_id: null,
        answer_text: "",
        input_answer: stuckAffects,
      };
    } else if (selectedQuest == 113 && highestNum) {
      setClickedSlide({ slide: e.target.name });
      flage = true;
      question_data = {
        question_id: selectedQuest,
        option_id: null,
        answer_text: "",
        input_answer: "£" + highestNum,
      };
    } else if (selectedQuest == 101 && incomeMonthly) {
      setClickedSlide({ slide: e.target.name });
      flage = true;
      question_data = {
        question_id: selectedQuest,
        option_id: null,
        answer_text: "",
        input_answer: incomeMonthly,
      };
    }

    if (flage) {
      storeFollowupQuestionnire(question_data, "followup_question_store");
      let existingEntries = JSON.parse(localStorage.getItem("questionData"));
      if (existingEntries == null) existingEntries = [];
      localStorage.setItem(
        "currentquestionData",
        JSON.stringify(question_data)
      );
      existingEntries.push(question_data);
      localStorage.setItem("questionData", JSON.stringify(existingEntries));
      if (selectedQuest == "106" && stuckAffects) {
        removeFromPendingFollowup("questionnaire");
      }
    }
  };

  const storeFollowupQuestionnire = async (question_data, msg_type) => {
    const response = await saveFollowupUserQuestions(
      question_data,
      allFollowupData,
      msg_type
    );
  };

  const SkippedLeads = async (type, flag = true) => {
    const skippedLeadsResponse = await SkippedLeads(type, uuid, "Followup-od");
    if (flag && skippedLeadsResponse.data.status == "Success") {
      // redirectToPreview();
    }
  };

  const saveSlide80 = async (e) => {
    let selectedAns = parseInt(e.target.getAttribute("data-ans-id"));
    let selectedQuest = parseInt(e.target.getAttribute("data-quest-id"));

    // setCompletedQuestArr([...completedQuestArr, selectedQuest]);

    const values = getValues();
    let slide_array = [];

    if (checklistOptions.some((option) => option.id === 229)) {
      let answer229 = splitForm.current["question_228_229"].value;
      slide_array.push(["229", "£" + answer229]);
    }
    if (checklistOptions.some((option) => option.id === 230)) {
      let answer230 = splitForm.current["question_230"].value;
      slide_array.push(["230", "£" + answer230]);
    }
    if (checklistOptions.some((option) => option.id === 231)) {
      let answer231 = splitForm.current["question_231"].value;
      slide_array.push(["231", "£" + answer231]);
    }
    if (checklistOptions.some((option) => option.id === 232)) {
      let answer232 = splitForm.current["question_232"].value;
      slide_array.push(["232", "£" + answer232]);
    }
    if (checklistOptions.some((option) => option.id === 233)) {
      let answer233 = splitForm.current["question_233"].value;
      slide_array.push(["233", "£" + answer233]);
    }
    if (checklistOptions.some((option) => option.id === 234)) {
      let answer234 = splitForm.current["question_234"].value;
      slide_array.push(["234", "£" + answer234]);
    }

    if (checklistOptions.some((option) => option.id === 296)) {
      let answer296 = splitForm.current["question_296"].value;
      slide_array.push(["296", "£" + answer296]);
    }

    if (checklistOptions.some((option) => option.id === 297)) {
      let answer297 = splitForm.current["question_297"].value;
      slide_array.push(["297", "£" + answer297]);
    }

    if (checklistOptions.some((option) => option.id === 235)) {
      let answer235 = splitForm.current["question_235"].value;
      slide_array.push(["235", "£" + answer235]);
    }

    var question_data = {
      slide_80: ["80", JSON.stringify(slide_array)],
    };

    setClickedSlide({ slide: "incmAndexp" });
    storeQuestionnire(question_data);
    removeFromPending("incmAndExp");

    let _existingEntries = JSON.parse(localStorage.getItem("questionData"));
    if (_existingEntries == null) _existingEntries = [];
    let existingIndex = _existingEntries.findIndex(
      (entry) => entry.question_id === question_data.question_id
    );
    if (existingIndex !== -1) {
      _existingEntries.splice(existingIndex, 1);
    }
    _existingEntries.push(question_data);
    localStorage.setItem("questionData", JSON.stringify(_existingEntries));
  };

  const removeFromPending = (slidename) => {
    const index = questionSlides.indexOf(slidename);
    if (index > -1) {
      questionSlides.splice(index, 1);
    }

    slideChange(questionSlides);
  };

  const slideChange = (pendingQuestionSlides) => {
    let pendingCount = pendingQuestionSlides.length;
    if (pendingCount == 0) {
      removeFromPendingFollowup("questionnaire");
      completePageLeadStatus();
      return false;
    }
    pendingQuestionSlides?.every((element) => {
      dispatch({ type: "showSlideChange", payload: element });
    });
  };


  const completePageLeadStatus = () => {
    const data = {
      uuid,
      page_name: getPageName("questions"),
      status: "completed",
      source: flp_source,
    };
    (async () => {
      await savePageLoad(
        visitorParameters.visitor_parameters,
        data,
        "visited_status",
        splitName,
        queryString,
        visitorParameters.data
      );
    })();
  }
  return (
    <>
      <GetVisitorsParams />
      <div className="questionnaireUFC_DC_V1">
        <form
          ref={splitForm}
          name="split_form"
          id="user_form"
          autoComplete="off"
        >
          <section className="banner  parallax-container">
            <div className="d-lg-none d-md-none d-sm-block d-block money-bg-mobile">
              <img
                src="../../assets/QuestionaireUFC_DC_V1/img/bg-money-sml.png"
                alt=""
              />
            </div>
            <div className="container" ref={scrollfrmv2div}>
              <div>
                <div className="brand">
                  <div className="logo pt-3">
                    {/* <a href="index.html"> */}{" "}
                    <img
                      src="../../assets/QuestionaireUFC_DC_V1/img/logo-white.png"
                      height={60}
                      alt=""
                    />
                    {/* </a> */}
                  </div>
                </div>
              </div>
            </div>

            <div className="container pt-5 px-lg-2 px-md-2 px-sm-0 px-0  ">
              <div className="inner-section fullqs-list">
                {/* <div className="inner1">
                  <div className="mb-4">
                    <h2 className="text-progress ">Question</h2>
                    {/* <div
                                            className="progress"
                                            role="progressbar"
                                            aria-label="Info example"
                                            aria-valuenow={25}
                                            aria-valuemin={0}
                                            aria-valuemax={100}
                                        >
                                            <div className="progress-bar bg-success" style={{ width: "10%" }}>
                                                10%
                                            </div>
                                        </div> 
                  {/*}  <div
                      className="progress"
                      aria-label="Progress Bar"
                      aria-valuemin={0}
                      aria-valuemax={100}
                      aria-valuenow={percentage}
                    >
                      {/* Progress bar that animates left to right
                      <div
                        className="progress-bar"
                        style={{
                          width: `${percentage}%`, // Dynamic width based on the percentage
                        }}
                      >
                        {/* Display percentage value 
                        {percentage > 0 && `${percentage}%`}
                      </div>
                    </div>
                  </div>
                </div> 
                {/*
                                <div className="mb-lg-4 mb-sm-3 mb-sm-3 mb-3">
                                    <h1
                                        className={`${state.title1} fw-bold text-lg-center  text-md-center text-sm-start text-start `}
                                        id="titl1"
                                    >
                                        {" "}
                                        About your overdraft facility{" "}
                                    </h1>
                                    <h1
                                        className={`${state.title2} fw-bold text-lg-center  text-md-center text-sm-start text-start`}
                                        id="titl2"
                                        style={{ display: "none" }}
                                    >
                                        Your financial commitments when you took the overdraft{" "}
                                    </h1>
                                    <h1
                                        className={`${state.title3} fw-bold text-lg-center  text-md-center text-sm-start text-start`}
                                        id="titl2"
                                        style={{ display: "none" }}
                                    >
                                        Your financial commitments during the duration of the overdraft{" "}
                                    </h1>
                                </div>
                                */}
                <div className="body-questionnaire mb-4">
                  <div className="inner rounded-4">
                    {/* Slides */}
                    <OccasionalUnforeseenEmergency
                      clsName={`${state.occasionalUnforeseenEmergency}`}
                      onSelectAnswer={onSelectAnswer}
                      unQualifiedAnswer={unQualifiedAnswer}
                    />
                    {/* Slides */}
                    <ApplythisFollowing
                      clsName={`${state.applythisFollowing}`}
                      questArr={ApplythisFollowingOD}
                      optionSelected={optionSelected}
                      backClick={previousSlideChange}
                      onSelectAnswer={onSelectAnswer}
                      setHighestNumBck={setHighestNumBck}
                    />
                    <HighestNum
                      clsName={`${state.highestNum}`}
                      trigger={trigger}
                      validation={register}
                      getValues={getValues}
                      saveInputAns={saveInputAns}
                      backClick={previousSlideChange}
                      removeFromPending={removeFromPending}
                    />
                    {/* Slides */}
                    <OfferLoans
                      clsName={`${state.offerLoans}`}
                      backClick={previousSlideChange}
                      onSelectAnswer={onSelectAnswer}
                      highestNumBck={highestNumBck}
                    />
                    {/* Slides */}
                    <OpeningCreditLimit
                      clsName={`${state.openingCreditLimit}`}
                      trigger={trigger}
                      validation={register}
                      getValues={getValues}
                      saveInputAns={saveInputAns}
                      backClick={previousSlideChange}
                      removeFromPending={removeFromPending}
                    />

                    {/* Slides */}
                    <EverIncreCredLimit
                      clsName={`${state.everIncresedCredLimit}`}
                      setEverIncreased={setEverIncreased}
                      onSelectAnswer={onSelectAnswer}
                      backClick={previousSlideChange}
                      removeFromPending={removeFromPending}
                    />

                    {/* Slides */}
                    <BankActedIrresponsibly
                      clsName={`${state.bankActedIrresponsibly}`}
                      onSelectAnswer={onSelectAnswer}
                      backClick={previousSlideChange}
                    // unQualifiedAnswer={unQualifiedAnswer}
                    />

                    {/* Slides */}
                    <HighestCreditLimit
                      clsName={`${state.highestCreditLimit}`}
                      trigger={trigger}
                      validation={register}
                      getValues={getValues}
                      saveInputAns={saveInputAns}
                      backClick={previousSlideChange}
                      removeFromPending={removeFromPending}
                    />
                    {/* Slides */}
                    <ExceedCreditLimit
                      clsName={`${state.exceedCredLimit}`}
                      everIncreased={everIncreased}
                      setExceedCredit={setExceedCredit}
                      onSelectAnswer={onSelectAnswer}
                      backClick={previousSlideChange}
                      removeFromPending={removeFromPending}
                    />

                    {/* Slides */}
                    <HowOftenExceedCredit
                      clsName={`${state.oftenExceedCredit}`}
                      onSelectAnswer={onSelectAnswer}
                      backClick={previousSlideChange}
                    />
                    {/* Slides */}
                    <OverLimitCharges
                      clsName={`${state.overLimit}`}
                      onSelectAnswer={onSelectAnswer}
                      backClick={previousSlideChange}
                    />
                    {/* Slides */}
                    <SufferedFinancialHardship
                      clsName={`${state.financialHardship}`}
                      exceedCredit={exceedCredit}
                      onSelectAnswer={onSelectAnswer}
                      backClick={previousSlideChange}
                    />

                    <RecieveAnyIncome
                      clsName={`${state.recieveAnyIncome}`}
                      setRecieveIncomeback={setRecieveIncomeback}
                      onSelectAnswer={onSelectAnswer}
                      removeFromPending={removeFromPending}
                    />

                    <MonthlyIncome
                      clsName={`${state.monthlyIncome}`}
                      trigger={trigger}
                      validation={register}
                      getValues={getValues}
                      saveInputAns={saveInputAns}
                      backClick={previousSlideChange}
                      removeFromPending={removeFromPending}
                    />

                    <Dependents
                      clsName={`${state.dependents}`}
                      recieveIncomeback={recieveIncomeback}
                      onSelectAnswer={onSelectAnswer}
                      backClick={previousSlideChange}
                    />

                    <WereAlreadyPaying
                      clsName={`${state.wereAlreadyPaying}`}
                      onSelectAnswer={onSelectAnswer}
                      questArr={wereUalreadyPayingOD}
                      validation={register}
                      validationMsg={errors}
                      getValues={getValues}
                      trigger={trigger}
                      setError={setError}
                      checklistOptions={checklistOptions}
                      backClick={previousSlideChange}
                      setChecklistOptions={setChecklistOptions}
                    />

                    <IncomeAndExpV2
                      clsName={`${state.incmAndExp}`}
                      validation={register}
                      validationMsg={errors}
                      getValues={getValues}
                      trigger={trigger}
                      setError={setError}
                      splitForm={splitForm}
                      questArr={wereUalreadyPayingOD}
                      saveSlide80={saveSlide80}
                      // scrollToElement={scrollToElement}
                      backClick={previousSlideChange}
                      checklistOptions={checklistOptions}
                    />

                    <DidTakeFurtherBorrowing
                      clsName={`${state.didTakeFurtherBorrowing}`}
                      onSelectAnswer={onSelectAnswer}
                      removeFromPending={removeFromPending}
                      setStrugleRepaymentsBck={setStrugleRepaymentsBck}
                    />

                    <FurtherBorrowing
                      clsName={`${state.furtherBorrowing}`}
                      onSelectAnswer={onSelectAnswer}
                      setCheckedOptions={setCheckedOptions}
                      checkedOptions={checkedOptions}
                      backClick={previousSlideChange}
                    />

                    <StruggledRepayments
                      clsName={`${state.struggledRepayments}`}
                      onSelectAnswer={onSelectAnswer}
                      backClick={previousSlideChange}
                      strugleRepaymentsBck={strugleRepaymentsBck}
                    />

                    <MaintainedCreditBalance
                      clsName={`${state.maintainedCreditBalance}`}
                      onSelectAnswer={onSelectAnswer}
                      backClick={previousSlideChange}
                    />

                    <StuckInOverdraft
                      clsName={`${state.stuckInOverdraft}`}
                      setStuckinOverdraftbck={setStuckinOverdraftbck}
                      onSelectAnswer={onSelectAnswer}
                      removeFromPending={removeFromPending}
                    />

                    <HowStuckAffects
                      clsName={`${state.howStuckAffects}`}
                      saveInputAns={saveInputAns}
                      backClick={previousSlideChange}
                      stuckinOverdraftbck={stuckinOverdraftbck}
                      trigger={trigger}
                      validation={register}
                      getValues={getValues}
                      removeFromPending={removeFromPending}
                    />
                    {/* Slides */}
                    <div className="mt-2 mb-3 d-lg-flex justify-content-center  align-items-center text-center slide-up-now">
                      <div className=" pe-lg-3 pe-md-3 ps-sm-0 pe-0 mb-lg-0 mb-md-0 mb-sm-4  mb-4"></div>
                      <div>
                        <img
                          height={28}
                          src="../../assets/QuestionaireUFC_DC_V1/img/ssl.png"
                          alt=""
                        />{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <Footer />
        </form>
      </div>
    </>
  );
};

export default QuestionaireFlp;
